import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { TransferService, WalletService } from "@/services";
import debounce from "lodash-es/debounce";

export default {
  name: "operations-in-table",
  components: {},
  props: [],
  data() {
    return {
      route: {
        deposit: "deposit",
        withdraw: "withdrawal",
        exchange: "exchange",
        transfer: "transfer",
        marketConditions: ""
      },
      checkWalletLoading: false
    };
  },
  computed: {
    ...mapGetters({
      getMarketConditions: types.wallets.getters.GET_MARKET_CONDITIONS_WALLETS,
      userInfo: types.userInfo.getters.GET_USER_INFO,
      newWallets: types.wallets.getters.GET_NEW_WALLETS
    })
  },
  watch: {
    getMarketConditions: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.marketConditions = newValue;
        }
      }
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      queryIsoAction: types.operations.actions.SET_OPERATION_QUERY_ISO,
      setOpenModalMarketConditions:
        types.wallets.actions.SET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS,
      setMarketConditions: types.wallets.actions.SET_MARKET_CONDITIONS_WALLETS,
      updateCheckWallets: types.wallets.actions.UPDATE_CHECK_WALLETS,
      setNewWallets: types.wallets.actions.SET_NEW_WALLETS
    }),
    updateWalletID(id) {
      this.checkWalletLoading = true;
      this.callUpdateWalletID(id);
    },
    callUpdateWalletID: debounce(function(id) {
      WalletService.updateWalletV4(id)
        .then(response => {
          this.updateCheckWallets({
            id: id,
            show_update: false
          });
          this.$toast.success(response.data.message);
          WalletService.getWalletV2().then(res => {
            this.setNewWallets(res.data.data.wallets);
            setTimeout(() => {
              this.updateCheckWallets({
                id: id,
                show_update: true
              });
            }, response.data.data.user_check_wallet_interval);
          });
        })
        .catch(error => {
          this.$toast.error(error.data.message);
          if (error.status) {
            this.checkWalletLoading = false;
          }
        })
        .finally(() => {
          this.checkWalletLoading = false;
        });
    }, 2000),
    changeUrlAndSetQueryParameter(iso, route) {
      if (route === "deposit" && iso === "IRR") {
        this.$router.push({
          path: `/operations/` + route,
          query: { from: iso, paymentType: "online" }
        });
      } else if (route === "transfer") {
        // if (this.marketConditions) {
        //   this.$router.push({
        //     path: `operations/` + route,
        //     query: { from: iso }
        //   });
        // } else {
        TransferService.getUserAgreement()
          .then(response => {
            if (response.data.data.agreement_status) {
              // this.setMarketConditions(response.data.data.agreement_status);
              this.$router.push({
                path: `/operations/transfer`,
                query: { from: iso }
              });
            } else {
              this.setOpenModalMarketConditions(true);
            }
          })
          .catch(error => {
            this.$toast.error(error.data.message);
          });
      } else {
        this.$router.push({
          path: `/operations/` + route,
          query: { from: iso }
        });
      }
      this.queryIsoAction(iso);
    }
  }
};
